import { useEffect, useState } from "react";

import { CompanyPartHeader } from "../../../components/PartHeader";
import { CompanyTitledPage } from "../../TitledPage";


import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

import { useLocation, useNavigate } from "react-router-dom";

import { SYSTEM_PATH_COMPANY } from "../../../App";
import {
  searchCustomerInfoList,
  searchShopInfoList
} from "../../../http/api/CustomerAPI";

const infoTableCellSx = {
  fontSize: 18,
};

const getCustomerLocationState = (customerId) => ({
  customerId: customerId,
});

const getShopEditLocationState = (customerId, shopId) => ({
  customerId: customerId,
  shopId: shopId,
});

// 店舗情報表
// props...data = 表のデータ
function ShopInfoTable(props) {
  const { customer, shop } = props;
  console.log(customer);
  console.log(shop);

  return (
    <TableContainer component={Box}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell width={180} sx={infoTableCellSx}>
              取引先名
            </TableCell>
            <TableCell sx={infoTableCellSx}>{customer.customerName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>
              店舗名
            </TableCell>
            <TableCell sx={infoTableCellSx}>{shop.shopName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>店舗名ふりがな</TableCell>
            <TableCell sx={infoTableCellSx}>{shop.shopNameFurigana}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>住所</TableCell>
            <TableCell sx={infoTableCellSx}>
              {/* 〒{getHyphenedPostCode("")} */}
              <br />
              {shop.address || ""}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>TEL</TableCell>
            <TableCell sx={infoTableCellSx}>{shop.tel || ""}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>FAX</TableCell>
            <TableCell sx={infoTableCellSx}>{shop.fax || ""}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>Email</TableCell>
            <TableCell sx={infoTableCellSx}>{shop.email || ""}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>買人No.</TableCell>
            <TableCell sx={infoTableCellSx}>{shop.buyerNo || ""}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={infoTableCellSx}>コンテナ数</TableCell>
            <TableCell sx={infoTableCellSx}>
              {shop.containerQuantity}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

// 店舗情報表示ページ
export default function ShopInformationPage() {
  const location = useLocation();

  const navigate = useNavigate();

  const [openDeleteShopDialog, setOpenDeleteShopDialog] = useState(false);
  // 取引先情報
  const [customer, setCustomer] = useState({});
  // 店舗情報
  const [shop, setShop] = useState({});

  const customerId = location.state.customerId;
  const shopId = location.state.shopId;

  // 取引先情報を取得
  useEffect(() => {
    GetCustomerInfo();
  }, []);
  async function GetCustomerInfo() {
    let response = await searchCustomerInfoList({ customerId });
    setCustomer(response.listCustomerInfo[0]);
  }

  //店舗情報を取得
  useEffect(() => {
    GetShopInfo();
  }, []);
  async function GetShopInfo() {
    let response = await searchShopInfoList({ shopId });
    setShop(response.listShopInfo[0]);
  }

  const onClickReturnCustomerInfo = (event) => {
      navigate(SYSTEM_PATH_COMPANY + "/customer_information", {
        state: getCustomerLocationState(customerId),
      });
  };

  const onClickEdit = (event) => {
    navigate(SYSTEM_PATH_COMPANY + "/shop_information_edit", {
      state: getShopEditLocationState(customerId, shopId),
    });
  };

  const onClickDelete = (event) => {
    setOpenDeleteShopDialog(true);
  };

  const onCloseDeleteShopDialog = (event, deleted) => {
    setOpenDeleteShopDialog(false);
    if (deleted) {
      navigate(SYSTEM_PATH_COMPANY + "/customer_information", {
        state: getCustomerLocationState(customerId),
      });
    }
  };

  return (
    <CompanyTitledPage title="店舗情報表示">
      
      <Grid container spacing={2}>
        <Grid item xs="auto">
          {/* 取引先名 */}
          <Typography fontWeight="bold" fontSize={30}>
            {customer.customerName}
          </Typography>
        </Grid>
        <Grid item xs>
          {/* 店舗名 */}
          <Typography fontWeight="bold" fontSize={30}>
            {shop.shopName}
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <Button variant="outlined" onClick={onClickReturnCustomerInfo}>
            取引先情報に戻る
          </Button>
        </Grid>
      </Grid>

      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              店舗情報
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={onClickEdit}>
              編集
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" color="error" onClick={onClickDelete}>
              店舗を削除
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      <ShopInfoTable customer={customer} shop={shop} />

      {/* <DeleteShopDialog open={openDeleteShopDialog} onCloseDialog={onCloseDeleteShopDialog} customerData={customerData} shopData={shopInfoData} /> */}
    </CompanyTitledPage>
  );
}
